// hooks
import { useBlockType } from "../../contexts/BlockTypeContext";
// components
import RichTextEditor from "components/rich-text-editor/RichTextEditor";
// styles
import styles from "./styles.module.scss";
// types
import type { BlockItemWithUploadProps } from "../../types";
import getClasses from "utils/getClasses";
// constants
const PLACEHOLDER = "Short answer text";

const ShortAnswer = ({
  value,
  onChange,
  onUpload,
  gptBusy,
}: BlockItemWithUploadProps) => {
  const { isFill, isEdit, disabled } = useBlockType();

  return (
    <RichTextEditor
      className={getClasses(
        styles["short-answer"],
        disabled && styles["short-answer--disabled"],
      )}
      editorClassName={styles["short-answer__editor"]}
      disabled={isEdit || disabled || gptBusy}
      readOnly={!isFill || disabled}
      value={value || ""}
      placeholder={PLACEHOLDER}
      onUpload={onUpload}
      {...(isFill && {
        onChange: (e) => onChange && onChange(e),
      })}
    />
  );
};

export default ShortAnswer;
